"use client"
import Image from "next/image"
import { useState } from "react"
import type { ImagePropsWithFallback } from "../types"
import { getImgixUrl } from "./utils"

interface ImgixImageWithFallbackProps extends ImagePropsWithFallback {
  src: string
}
export default function ImgixImageWithFallback({
  fallbackSrc,
  ...props
}: ImgixImageWithFallbackProps) {
  const [error, setError] = useState(false)

  if (error && fallbackSrc) return <Image {...props} src={fallbackSrc} />
  if (error) return null

  return <Image {...props} onError={() => setError(true)} loader={getImgixUrl} />
}
